module.exports = __webpack_public_path__ + "img/research_yingchuan.142c9cd9.png";